<template>
  <div class="NewsDetail">
    <section-header
      heading="2"
      ja="「i my merry with PRINCESS PEACH」イベント開始！"
    />
    <div>
      <div class="text-area">
        24.03.21<br /><br />Nintendo Switch用ソフト「プリンセスピーチ
        Showtime!」発売記念！<br /><br />
        <center>♡ピーチ姫がi my merryに登場♡</center>
        <br />
        <center>
          <img
            src="https://d4.puri.jp/dev/banner/news/20240321_princess_peach_01.jpg"
            style="max-width: 100%;"
          />
        </center>
        <br />
        <center>
          <a href="https://puri.sega.jp/info/princess-peach/"
            >イベント特設サイトはこちら</a
          >
        </center>
        <br /><br />
        ■実施期間<br />
        2024年3月21日(木) ～ 4月22日(月)<br /><br />
        ■対象機種<br />
        全国の「i my merry（アイマイメリー）」<br />
        <center>
          <img
            src="https://d4.puri.jp/dev/banner/news/20240321_princess_peach_02.png"
            style="max-width: 85%;"
          />
        </center>
        i my merryがピーチ姫デザインに変身♡<br /><br />
        <center>
          <a href="https://puri.sega.jp/info/princess-peach/location"
            >遊べるお店はこちら</a
          >
        </center>
        <br />
        ※通常デザインのi my merryでも同じ内容でプレイできます<br /><br />
        ■内容<br />受付で「イベントモード」を選択して進むと、BGMがピーチ姫の楽曲に♪<br />
        撮影中もピーチ姫気分に♡<br /><br />
        撮影後は、スタンプ全14種、フレーム全5種、イベント限定のシールデザイン１種が期間限定で使えるよ！<br /><br />
        <center>
          <img
            src="https://d4.puri.jp/dev/banner/news/20240321_princess_peach_03.png"
            style="max-width: 100%;"
          />
        </center>
        <br /><br />今だけ！のピーチ姫デザインになった可愛いi my merryをお店で見つけてね♡<br /><br />
        <center>
          <a href="https://puri.sega.jp/info/princess-peach/location"
            >遊べるお店はこちら</a
          >
        </center>
        <br /><br />
        シールが出てきたら、<br />
        連動アプリ「プリクラON」で<br />
        プリデータのダウンロードも忘れずに♪<br /><br />
        ダウンロードすると、<br />
        3秒動画「モーメント」も見れるよ！<br />
        SNSにもアップしてね♪<br /><br />
        プリクラONのカメラで<br />
        撮影したシールを見ると<br />
        シールが動く「ARプリクラ」も<br />
        楽しめるから試してみてね♪<br /><br />
        ■Nintendo Switch用ソフト「プリンセスピーチ Showtime!」とは<br />
        ピーチが主役のShowが幕を開ける<br />
        たくさんの舞台が上演されている「キラメキ劇場」にやってきたピーチ姫御一行。そこに突如現れた「グレープ劇団」により、劇場が乗っ取られてしまいます。悲劇と化した舞台を救うため、ピーチはグレープ劇団に立ち向かいます。<br />
        詳細は任天堂ホームページのこちらをご覧ください。<br />
        <a href="https://www.nintendo.com/jp/switch/amjja/index.html">
          https://www.nintendo.com/jp/switch/amjja/index.html
        </a>
        <br /><br />
        権利表記：© Nintendo&emsp; 
        Nintendo Switchは任天堂の商標です。<br /><br />
        セガ公式SNSでも最新情報を発信中！<br /><br />
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
          <a class="snsIcon" href="https://www.tiktok.com/@sega_purikura">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_04_TT.jpg">
          </a>
        </div>
        <br /><br />
        © SEGA<br />
        © Nintendo<br /><br />
        <center>
          <a href="https://puri.sega.jp/info/princess-peach/"
            >イベント特設サイトはこちら</a
          >
        </center>
        <br />
      </div>
      <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
      <sub-btn @click="onHome()">ホームに戻る</sub-btn>
    </div>
  </div>
</template>

<script>
import Protobuf from "../mixins/protobuf";
import SectionHeader from "../components/SectionHeader";
import SubBtn from "../components/SubBtn.vue";

export default {
  name: "newsPeachShowtime",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    };
  },
  methods: {
    onNewsList() {
      this.$router.push("/newsList");
    },
    onHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    p {
      margin-top: 1em;
    }

    .linkArea {
      .twitter {
        margin: 0 5px;
      }
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      & > a:not(:last-of-type) {
        margin-right: 30px;
      }

      & > a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}
</style>
